import { useState } from "react";
import CommonModal from "./DumpModal";
import UploadFileModal from "./UploadFileModal";
import LoadURLModal from "./LoadURLModal";
import TellUsMoreModal from "./TellUsMoreModal";

const ChangeSourceModal = ({
  isOpen,
  onClose,
  currentSource,
  refetch,
  setRefetch,
}) => {
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [openURLModal, setOpenURLModal] = useState(false);
  const [openTellUsModal, setOpenTellUsModal] = useState(false);

  const handleUploadModal = () => {
    setOpenUploadModal(!openUploadModal);
    onClose();
  };

  const handleTellUsModal = () => {
    setOpenTellUsModal(!openTellUsModal);
    onClose();
  };

  const handleURLModal = () => {
    setOpenURLModal(!openURLModal);
    onClose();
  };
  return (
    <>
      <CommonModal title="Change Source" isOpen={isOpen} onClose={onClose}>
        <div className="mt-7 group">
          <button
            onClick={handleURLModal}
            className="w-full text-left bg-gray-50 border !border-gray-200 rounded-lg p-7 flex justify-between items-center group-hover:bg-green-100"
          >
            <div>
              <div className="text-md mb-1 font-medium text-gray-800">
                Add Your Website
              </div>
              <div className="text-sm text-gray-500">
                Your business website URL
              </div>
            </div>
            <span className="text-2xl text-black hidden group-hover:block">
              →
            </span>
          </button>
        </div>

        <div className="mt-3 mb-6 group">
          <button
            onClick={handleUploadModal}
            className="w-full text-left bg-gray-50 border !border-gray-200 rounded-lg p-7 flex justify-between items-center group-hover:bg-green-100"
          >
            <div>
              <div className="text-md mb-1 font-medium text-gray-800">
                Upload a file
              </div>
              <div className="text-sm text-gray-500">
                E.g. Brochure, sales pitch or brand guidelines{" "}
              </div>
            </div>
            <span className="text-2xl text-black hidden group-hover:block">
              →
            </span>
          </button>
        </div>

        <div className="mt-3 mb-6 group">
          <button
            onClick={handleTellUsModal}
            className="w-full text-left bg-gray-50 border !border-gray-200 rounded-lg p-7 flex justify-between items-center group-hover:bg-green-100"
          >
            <div>
              <div className="text-md mb-1 font-medium text-gray-800">
                Tell Us More
              </div>
              <div className="text-sm text-gray-500">
                Answer some questions so we can get to know you
              </div>
            </div>
            <span className="text-2xl text-black hidden group-hover:block">
              →
            </span>
          </button>
        </div>
      </CommonModal>
      <UploadFileModal
        isOpen={openUploadModal}
        onClose={handleUploadModal}
        setModal={setOpenUploadModal}
        currentSource={currentSource}
        refetch={refetch}
        setRefetch={setRefetch}
      />
      <LoadURLModal
        isOpen={openURLModal}
        setModal={setOpenURLModal}
        onClose={handleURLModal}
        currentSource={currentSource}
        refetch={refetch}
        setRefetch={setRefetch}
      />
      <TellUsMoreModal
        isOpen={openTellUsModal}
        onClose={handleTellUsModal}
        setModal={setOpenTellUsModal}
        setRefetch={setRefetch}
        refetch={refetch}
        currentSource={currentSource}
      />
    </>
  );
};

export default ChangeSourceModal;
